module.exports = __webpack_public_path__ + "img/radiance.d7faa725.jpg";